import { RouterType } from '@online-webinar/router';
import { FollowUpProcessedPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/follow-up/$followUpId/processed'].update({
        staticData: { title: { page: 'ProcessedFollowUp.PageHeading', forWebinar: true } },
        component: authGuard(FollowUpProcessedPage, { canBroadcast: true })
    });
};
